$( document ).on('turbolinks:load', function() {
	if($(".collapsible").length > 0){
		var coll = $(".collapsible");
		var i;

		for (i = 0; i < coll.length; i++) {
		  coll[i].addEventListener("click", function() {
		    this.classList.toggle("active");
		    var content = this.nextElementSibling;
		    if (content.style.maxHeight){
		      content.style.maxHeight = null;
		    } else {
		      content.style.maxHeight = content.scrollHeight + "px";
		    } 
		  });
		}
	}
	
	
	$('#carousel-mobile').carousel({
        num: 3,
        maxWidth: 305,
        maxHeight: 620,
        distance: 80,
        autoPlay: true
    });
	


	

	if($('#hex-grid').length > 0){
		const light = document.querySelector(".light");
		const grid = document.querySelector("#hex-grid");
		
		grid.addEventListener('mousemove', function(e){
			light.style.left = `${e.clientX}px`;
			light.style.top = `${e.clientY}px`;
		});
	}
	


	$(".navbar-toggler").click(function(){
		if($('#navbarSupportedContent').hasClass('show')){
			$('#navbarSupportedContent').removeClass('show');
		}else{
			$('#navbarSupportedContent').addClass('show');
		}
	})

	$('#prime').click(function() {
	  toggleFab();
	});

	//Toggle chat and links
	function toggleFab() {
	  hideChat();

	  $('.prime').toggleClass('fab fa-whatsapp');
	  $('.prime').toggleClass('far fa-times-circle');
	  $('.prime').toggleClass('is-active');
	  $('.prime').toggleClass('is-visible');
	  $('#prime').toggleClass('is-float');
	  $('.chat').toggleClass('is-visible');
	  $('.fab').toggleClass('is-visible');
	  
	  
	}

	function hideChat() {
	    if($("#chat-list").css('display') === 'none'){
	    	$('#chat-list').css('display', 'block');
	    }else{
	    	$('#chat-list').css('display', 'none');
	    }
	}


	if($("#client-list").length > 0){

		$.each(['technology', 'comodity', 'education', 'health', 'goverment'], function( index, value ) {
			$('#tab-b-' + value).click(function() {
			  
			  if(!$('#clients-' + value).hasClass("splide--loop")){


			  	setTimeout(function() {
				    new Splide( ('#clients-' + value), {
			            type: 'loop',
			            perPage: 4,
			            focus: 'center',
			            gap: '3rem',
			            padding: {
			              left: 30,
			              right: 30,
			            },
			            arrow: true,
			            pagination: 'slider',
			            breakpoints: {
			              '640': {
			                perPage: 1
			              },
			              '768': {
			                perPage: 2
			              }
			            }
			        }).mount()
				}, 200);
			  	




			  }



			});
		});


		
	}

	setTimeout(function() {
		$('#carousel-mobile').carousel({
	        num: 3,
	        maxWidth: 305,
	        maxHeight: 620,
	        distance: 80,
	        autoPlay: false
	    });
	}, 150);

});